/** Presentation inputs for convoy live marker popups (outside clustering). */
export type ConvoyTrackerPresentation = {
  label: (deviceId: number) => string;
  exceptionTitles: (deviceId: number) => readonly string[];
};

export function emptyConvoyTrackerPresentation(): ConvoyTrackerPresentation {
  return {
    label: (deviceId) => `#${deviceId}`,
    exceptionTitles: () => [],
  };
}

export function resolveConvoyTrackerPresentation(
  presentation: ConvoyTrackerPresentation | undefined,
): ConvoyTrackerPresentation {
  return presentation ?? emptyConvoyTrackerPresentation();
}
